<a (click)="onPress.emit($event)" class="link-bold-underline">
  {{ label }}
</a>
